<template>
  <div
    class="p-4 gap-4 flex flex-col justify-center text-center bg-white rounded-2xl"
  >
    <span class="font-bold text-xl text-[#606060]">{{
      $t('hub.sidebar.exercises.results.question', { index: index + 1 })
    }}</span>

    <div class="gap-4 flex flex-col flex-initial justify-center leading-normal">
      <div
        v-if="isIncorrect"
        class="gap-4 flex items-center text-left text-error"
      >
        <BaseIcon class="text-sm" icon="cross" />
        <span v-html="formattedIncorrectAnswer" />
      </div>

      <div class="gap-4 flex items-center text-left text-success">
        <BaseIcon class="text-sm" icon="check" />
        <span v-html="formattedCorrectAnswer" />
      </div>
    </div>

    <div v-if="explanation.content" class="p-2 text-left">
      <span class="whitespace-pre-line text-[#7C7C7C] leading-normal">
        💡 {{ explanation.content }}
      </span>
    </div>

    <BaseButton
      v-else
      class="mt-4"
      color="transparent"
      :is-loading="explanation.isLoading"
      @click="handleShowExplanation"
    >
      <span class="text-lg">{{
        $t('hub.sidebar.exercises.results.viewExplanation')
      }}</span>
    </BaseButton>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import BaseButton from '@/components/Base/BaseButton.vue'
import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'HubExercisesResultsHistoryListItem',

  components: { BaseButton, BaseIcon },

  props: {
    historyItem: { type: Object, required: true },
    index: { type: Number, required: true }
  },

  data: () => ({
    explanation: {
      isVisible: false,
      isLoading: false,
      content: ''
    }
  }),

  computed: {
    ...mapGetters('locale', ['currentLocale']),
    ...mapGetters('exercises', ['defineIsCorrect']),

    isCorrect() {
      return this.defineIsCorrect({
        exercise: this.historyItem.exercise,
        answer: this.historyItem.answer
      })
    },

    isIncorrect() {
      return !this.isCorrect
    },

    correctAnswer() {
      return this.historyItem.exercise.answers[0]
    },

    incorrectAnswer() {
      return this.historyItem.answer
    },

    formattedCorrectAnswer() {
      return this.historyItem.exercise.text.replace(
        '___',
        `<strong>${this.correctAnswer}</strong>`
      )
    },

    formattedIncorrectAnswer() {
      return this.historyItem.exercise.text.replace(
        '___',
        `<strong class="line-through">${this.incorrectAnswer}</strong>`
      )
    }
  },

  methods: {
    ...mapActions('exercises', {
      generateExplanation: 'GENERATE_EXPLANATION'
    }),

    async handleShowExplanation() {
      if (this.historyItem.explanation) {
        this.explanation.isVisible = true
        this.explanation.content = this.historyItem.explanation

        return
      }

      this.explanation.isVisible = true
      this.explanation.isLoading = true

      const { content } = await this.generateExplanation({
        historyItem: this.historyItem
      })

      this.explanation.isLoading = false
      this.explanation.content = content?.choices?.[0]?.message?.content || ''
    }
  }
}
</script>
